// removed by extract-text-webpack-plugin
module.exports = {"adsInfoContainer":"adsSummaryCard-module__adsInfoContainer___3lfyy","adsInfoHeading":"adsSummaryCard-module__adsInfoHeading___130nC","adsInfo":"adsSummaryCard-module__adsInfo___1hqw0","bolded":"adsSummaryCard-module__bolded___2stIV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/adsSummaryCard.module.scss
// module id = 308
// module chunks = 1